import { createContext } from 'react';
import { AnalyticsContextProps } from './analytics/types/Analytics.types';

// @ts-expect-error TS2345 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const AnalyticsContext = createContext<AnalyticsContextProps>(undefined);

export default AnalyticsContext;
